import { Text, View, type StyleProp, type TextStyle } from 'react-native';
import { useTranslation } from 'react-i18next';
import { muscleKey, todayOutOfTime, type TodayProposalView } from '@heraion/shared';

import { joinList } from '../joinList';

// #492 F5: the MEV muscles the minutes left at 0 sets, and the bodyweight scope
// of a draft with no bodyweight toggle (#540: built before it, or «anyway»).
export function TodayDraftLeftOut({
  proposal,
  style,
}: {
  proposal: TodayProposalView;
  style: StyleProp<TextStyle>;
}) {
  const { t, i18n } = useTranslation();
  const out = todayOutOfTime(proposal.rows);
  const scope = proposal.bodyweightOnly === true && proposal.candidatesBodyweight === undefined;
  if (out.length === 0 && !scope) return null;
  return (
    <View>
      {out.length > 0 ? (
        <Text style={style}>
          {t('progress.planGaps.leftOut', {
            muscles: joinList(
              out.map((m) => t(muscleKey(m))),
              i18n.language,
            ),
            defaultValue: 'Left out, not enough time: {{muscles}}.',
          })}
        </Text>
      ) : null}
      {scope ? (
        <Text style={style}>
          {t('progress.planGaps.draftBodyweightOnly', {
            defaultValue: 'Bodyweight exercises only.',
          })}
        </Text>
      ) : null}
    </View>
  );
}
